import React from 'react';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import './SocialMediaMaster.css';
import Loader from '../Loader/Loader';


const SocialMediaMaster = () => {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    shop_id: localStorage.getItem('ShopId') || '', 
    social_media: '',
    link: '',
    is_active: false,
  });
  const [editRowId, setEditRowId] = useState(null);
  const [shopDetails, setShopDetails] = useState(null);
  const [editedLink, setEditedLink] = useState("");
  // State for editing social media
  const [editedSocialMedia, setEditedSocialMedia] = useState("");
  const history = useHistory();
//   const [shopDetails, setShopDetails] = useState({
//   shop_address: "",
//   shop_mobile: "",
//   currency: "",
//   country: "",
// });



    useEffect(() => {
        fetchTables();
        fetchShopDetails();
      }, []);


      const fetchTables = async (id) => {
        const shop_id = localStorage.getItem('ShopId');
        const token = localStorage.getItem('Token');
        setLoading(true);
        console.log(id);
        try {
           const response = await axios.get(`${var_api}social-media/get/${shop_id}`,
            {
              headers: {
                Authorization: `${token}`, // Add the token to the Authorization header dynamically
              },
            });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setTables(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          setTables([])
        }
      };


      //fetch shop list
        const fetchShopDetails = async (id) => {
        const shop_id = localStorage.getItem('ShopId');
        const token = localStorage.getItem('Token');
        setLoading(true);
        console.log(id);
        try {
           const response = await axios.get(`${var_api}admin-employee/get-details/${shop_id}`,
            {
              headers: {
                Authorization: `${token}`, // Add the token to the Authorization header dynamically
              },
            });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setShopDetails(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          setShopDetails(null);
        }
      };


      const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
          ...formData,
          [name]: type === 'checkbox' ? checked : value,
        });
      };
    
      const handleCreateClick = () => {
        setShowModal(true);
      };
    
      const handleCloseModal = () => {
        setShowModal(false);
        setFormData({
          shop_id: localStorage.getItem('ShopId') || '',
          social_media: '',
          link: '',
          is_active: false,
        });
      };


      const handleReset = () => {
        setFormData({
          shop_id: localStorage.getItem('ShopId') || '',
          social_media: '',
          link: '',
          is_active: false,
        });
      }
    
      const handleSave = async () => {
        const token = localStorage.getItem('Token');
        try {
          const response = await axios.post(`${var_api}social-media/post`, formData, {
            headers: { Authorization: `${token}` },
          });
          Swal.fire('Success', 'Social media record added successfully!', 'success');
          handleCloseModal();
          fetchTables(); // Refresh the table
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          Swal.fire('Error', 'Failed to add social media record.', 'error');
        }
      };


      const handleToggleSwitch = async (id, newState) => {
        try {
          const token = localStorage.getItem('Token');
          const response = await axios.put(`${var_api}social-media/put/${id}`, 
            { is_active: newState ? 1 : 0 },
            { headers: { Authorization: token } }
          );
          Swal.fire('Success', 'Social media status updated successfully!', 'success');
          fetchTables(); // Refresh the data
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          Swal.fire('Error', 'Failed to update status', 'error');
        }
      };


      const handleEditClick = (id, currentLink, currentSocialMedia) => {
        if (editRowId === id) {
          // Save the edited link and social media
          updateLink(id, { link: editedLink, social_media: editedSocialMedia });
          setEditRowId(null); // Exit edit mode
        } else {
          // Enter edit mode
          setEditRowId(id);
          setEditedLink(currentLink);
          setEditedSocialMedia(currentSocialMedia);
        }
      };

      const updateLink = async (id, data) => {
        try {
          const token = localStorage.getItem('Token');
          await axios.put(`${var_api}social-media/put/${id}`, 
            data,
            { headers: { Authorization: token } }
          );
          Swal.fire('Success', 'Social media details updated successfully!', 'success');
          fetchTables(); // Refresh data
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          Swal.fire('Error', 'Failed to update social media details', 'error');
        }
      };
      
      
      const handleShopDetailsUpdate = async () => {
  try {
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token'); // Or from context, cookies, etc.

    const response = await axios.put(
      `${var_api}admin-employee/admin-put/${shop_id}`,
      shopDetails,
      {
        headers: {
          Authorization: token
        }
      }
    );

    if (response.data.message) {
       Swal.fire('Success', 'Shop details updated successfully!', 'success');
       await fetchShopDetails();
    } else {
      console.log("ee", response.data)
      //  Swal.fire('Error', 'Failed to add social media record!', 'error');
    }
  } catch (error) {
    console.error("Error updating shop details:", error);
    Swal.fire('Error', 'Error updating shop details!', 'error');
  }
};

    
      

   
    return(
    <>
  <Layout>
    <div className="container mt-4">
      <div className="row">
        {/* Left Column: Social Media */}
        <div className="col-md-6">
          <div
            style={{
              border: "none",
              padding: "20px",
              borderRadius: "15px",
              backgroundColor: "white",
              boxShadow:
                "rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px",
            }}
          >
            <div className="row">
              <div className="col">
                <h4 className="ushe">SOCIAL MEDIA</h4>
              </div>
              <div className="col">
                <button
                  className="btn btn-success"
                  style={{
                    float: "right",
                    margin: "5px",
                    borderRadius: "15px",
                  }}
                  onClick={handleCreateClick}
                >
                  Create
                </button>
              </div>
            </div>

            {loading ? (
              <Loader />
            ) : (
              <form className="py-2">
                {tables.map((data, index) => (
                  <div className="row mb-3" key={index}>
                    <div className="col-8">
                      <label
                        htmlFor="input1"
                        style={{
                          color: "green",
                          fontFamily: "serif",
                          fontWeight: "bolder",
                        }}
                      >
                        {data.social_media}
                      </label>
                      {/* {editRowId == data.id && (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Social Media Name"
                          value={
                            editRowId === data.id
                              ? editedSocialMedia
                              : data.social_media
                          }
                          onChange={(e) =>
                            setEditedSocialMedia(e.target.value)
                          }
                          style={{
                            borderRadius: "12px",
                            marginBottom: "10px",
                          }}
                          readOnly={editRowId !== data.id}
                        />
                      )} */}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter WhatsApp URL"
                        value={
                          editRowId === data.id ? editedLink : data.link
                        }
                        onChange={(e) =>
                          editRowId === data.id && setEditedLink(e.target.value)
                        }
                        style={{ borderRadius: "12px" }}
                        readOnly={editRowId !== data.id}
                      />
                    </div>

                    <div className="col-4 d-flex align-items-center justify-content-center">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          checked={data.is_active == 1}
                          onChange={() =>
                            handleToggleSwitch(data.id, !data.is_active)
                          }
                        />
                      </div>
                      <button
                        className="btn btn-primary"
                        style={{ marginLeft: "10px", borderRadius: "8px" }}
                        onClick={(e) => {
                          e.preventDefault();
                          handleEditClick(data.id, data.link);
                        }}
                      >
                        {editRowId === data.id ? "Save" : <i className="bi bi-pencil-square"></i>}
                      </button>
                    </div>
                  </div>
                ))}
              </form>
            )}
          </div>
        </div>

        {/* Right Column: Shop Details */}
        <div className="col-md-6">
          <div
            style={{
              border: "none",
              padding: "20px",
              borderRadius: "15px",
              backgroundColor: "white",
              boxShadow:
                "rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px",
            }}
          >
            <h4 className="ushe">SHOP DETAILS</h4>
            <br/>
              <br/>
            <form>
              <div className="mb-3">
                <label className="form-label">Shop Address</label>
                <input
                  type="text"
                  className="form-control"
                  value={shopDetails?.shop_address}
                  onChange={(e) =>
                    setShopDetails({
                      ...shopDetails,
                      shop_address: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Shop Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  value={shopDetails?.shop_mobile}
                  onChange={(e) =>
                    setShopDetails({
                      ...shopDetails,
                      shop_mobile: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Currency</label>
                <input
                  type="text"
                  className="form-control"
                  value={shopDetails?.currency}
                  onChange={(e) =>
                    setShopDetails({
                      ...shopDetails,
                      currency: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control"
                  value={shopDetails?.country}
                  onChange={(e) =>
                    setShopDetails({
                      ...shopDetails,
                      country: e.target.value,
                    })
                  }
                />
              </div>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleShopDetailsUpdate}
              >
                Update Shop Details
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

     <Modal show={showModal} onHide={handleCloseModal}>
  <Modal.Header closeButton>
    <Modal.Title>Create Social Media</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleSave}>
      <Form.Group controlId="socialMediaName">
        <Form.Label>Social Media Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter social media name"
          name="social_media"
          value={formData.social_media}
          onChange={handleInputChange}
          required
        />
      </Form.Group>
      <Form.Group controlId="link">
        <Form.Label>Link</Form.Label>
        <Form.Control
          type="url"
          placeholder="Enter link"
          name="link"
          value={formData.link}
          onChange={handleInputChange}
          required
        />
      </Form.Group>
      <Form.Group controlId="isActive">
        <Form.Check
          type="checkbox"
          label="Is Active"
          name="is_active"
          checked={formData.is_active}
          onChange={handleInputChange}
        />
      </Form.Group>
      <Button variant="primary" type="submit">
        Create
      </Button>
      <Button variant="secondary" onClick={handleReset}>
        Reset
      </Button>
    </Form>
  </Modal.Body>
</Modal>

  </Layout>
</>


        
    )
}

export default SocialMediaMaster;